<div>
  <h6 class="odx-title-6" i18n="@@global.dangerAreas">Gefahrenbereiche</h6>

  <app-floorplan-menu-item-buttons>
    <button
      odxButton
      class="danger-area"
      (click)="addDangerArea()"
      [odxTooltip]="tooltipText"
      [odxTooltipOptions]="{ position: 'bottom-start' }"
      draggable="true"
      (dragstart)="dragDangerArea()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
    </button>
    <app-toggle-visibility-button
      [visible]="floorplanState.dangerAreasVisible"
      (toggleEvent)="floorplanState.dangerAreasVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.dangerAreasItemTextVisible"
      (toggleEvent)="updateDangerAreasItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.dangerAreasLocked" (toggleEvent)="floorplanState.dangerAreasLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
